
<main>
    <svelte:component this={route}/>
</main>

<script>

    import { onMount } from 'svelte'
    import Navaid from 'navaid';

    import { onDestroy } from 'svelte';
    import { setContext } from 'svelte';

    // window.apiUrl = (isProduction) ? 'https://dev.api.aemtler-bon.ch' : 'http://localhost:8010/proxy';
    window.apiUrl = (isProduction) ? 'https://prod-api.dublonen.ch/aemtlerbon' : 'https://prod-api.dublonen.ch/aemtlerbon';

    let route, params={}, active;
    let uri = location.pathname;
    $: active = uri.split('/')[1] || 'dashboard';


    function run(thunk, obj) {

        const target = uri;

        thunk.then(m => {

            if (target !== uri) {

                return;
            }

            params = obj || {};

            if (m.preload) {

                m.preload({ params }).then(() => {

                    if (target !== uri) {

                        return;
                    }

                    route = m.default;
                    window.scrollTo(0, 0);

                });

            } else {

                route = m.default;
                window.scrollTo(0, 0);

            }

        });

    }

    function track(obj) {

        uri = obj.state || obj.uri || location.pathname;
    }

    addEventListener('replacestate', track);
    addEventListener('pushstate', track);
    addEventListener('popstate', track);

    const router = Navaid('/')
        .on('/', () => run(import('../routes/overview.svelte')))
        .listen();

    setContext('router', router);

    onDestroy(router.unlisten);

</script>

